import * as React from 'react';
import { Table, Button } from '../../components';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Query, Mutation, MutationFn } from 'react-apollo';
import GetAllContactUs from '../../graphql/queries/GetAllContactUs';
import ArchiveContactUs from '../../graphql/mutations/ArchiveContactUs';
import { theme } from '../../theme';
interface ContactUsData {
  contactuses: Array<{
    id: string;
    name: string;
    number?: string;
    email?: string;
  }>;
}

interface ContactUsState {
  searchTerm?: string;
}

class ContactUsManagement extends React.Component<RouteComponentProps, ContactUsState> {
  state = {
    searchTerm: undefined,
  };

  getColumns = (archiveContactUsMutation: MutationFn, archiving: boolean) => {
    const handleArchive = (id: string) => {
      if (window.confirm('Are you sure you want to archive this contact?')) {
        archiveContactUsMutation({ variables: { id } });
      }
    };

    return [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Telephone',
        accessor: 'number',
        Cell: (row: any) => <div>{row.value || '-'}</div>,
      },
      {
        Header: 'Email',
        accessor: 'email',
        Cell: (row: any) => <div>{row.value || '-'}</div>,
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: (row: any) => {
         console.log({row})
         return <div>{row.value || '-'}</div>
        },  
      },
      {
        Header: 'Actions',
        id: 'actions',
        width: 100,
        Cell: ({ row }: any) => (
          <Button
            bg={theme.colors.red}
            borderColor={theme.colors.red}
            color="white"
            height="30px"
            minWidth="80px"
            p="0 1em"
            type="button"
            // @ts-ignore
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation(); 
              handleArchive(row._original.id);
            }}
            disabled={archiving}
            text={archiving ? 'Archiving...' : 'Archive'}
          />
        ),
      },
    ];
  };

  handleButtonPress = () => {
    this.props.history.push('/contact-us/create-new');
  };

  render() {
    const { searchTerm } = this.state;
    return (
      <Mutation
        mutation={ArchiveContactUs}
        refetchQueries={[{ query: GetAllContactUs, variables: { searchTerm } }]}
        onError={(error) => {
          console.error('Error archiving contact us:', error);
        }}
      >
        {(archiveContactUsMutation: MutationFn, { loading: archiving }) => (
          <Query<ContactUsData> 
            query={GetAllContactUs}
            variables={{ searchTerm }}
            fetchPolicy="network-only"
          >
            {({ loading: queryLoading, error, data }) => {
              if (error) {
                return <div>Error loading contacts</div>;
              }

              return (
                <Table
                  heading="Contact Us Management"
                  data={data ? data.contactuses : []}
                  columns={this.getColumns(archiveContactUsMutation, archiving)}
                  loading={queryLoading || archiving}
                  onButtonPress={this.handleButtonPress}
                  onSearchCallback={(newSearchTerm: string) => this.setState({ searchTerm: newSearchTerm })}
                  onRowClick={(row) => {
                    const { id } = row.original;
                    if (id) {
                      console.log('ContactUsManagement - Navigating to:', `/contact-us/${id}/details`);
                      this.props.history.push(`/contact-us/${id}/details`);
                    }
                  }}
                />
              );
            }}
          </Query>
        )}
      </Mutation>
    );
  }
}

export default withRouter(ContactUsManagement);



// WEBPACK FOOTER //
// ./src/containers/contactUs/ContactUsManagement.tsx